import React from 'react';
import Slider, { Settings } from 'react-slick';
import ReactModal from 'react-modal';
import style from './imageGallery.module.scss';
import { FormattedMessage } from 'react-intl';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { CrossIcon } from 'acscp/components/common/icons/crossIcon';
import {Disclaimer} from 'acscp/components/quotes/quoteDetails';

export interface ImageGalleryProps {
    title: string | null;
    showCloseButton: boolean;
    showDisclaimer?: boolean;
    onClose?: () => void;
    onFullscreen?: () => void;
}

const slickSliderSettings: Settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,

    /**
     * Set "Previous" and "Next" arrows to be buttons without any text.
     * This resolves a problem on iPhone, where hidden text on these buttons would work as undesired padding.
     *
     * react-slick will automatically add several classes and button attributes,
     * so we only should provide the buttons themselves.
     */
    prevArrow: <button />,
    nextArrow: <button />
};

export const ImageGallery: React.SFC<ImageGalleryProps>
    = ({ title, onClose, onFullscreen, children, showCloseButton , showDisclaimer = false}) => {
    return (
        <div className={style.ImageGallery}>
            <Slider {...slickSliderSettings}>
                {children}
            </Slider>
            <div className={style.Title}>
                {title}
            </div>
            {showDisclaimer &&
                <div className={style.Disclaimer}>
                    <Disclaimer/>
                </div>
            }
            {showCloseButton &&
                <button className={style.CloseButton} onClick={onClose} aria-label="Close image gallery">
                    <CrossIcon addShadow={true} />
                </button>
            }
            {onFullscreen
                ? <button className={style.FullscreenButton} onClick={onFullscreen} />
                : null}
        </div>
    );
};
